export default [
  'auto',
  'cover',
  'contain'
]
